import { Button } from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { MdDownload } from 'react-icons/md';

import { useAlert } from '@app/hooks';

type TemplateDownloadProps = {
  label: string;
  method: () => Promise<ApiResponse<string>>;
};

export const TemplateDownload = ({
  label,
  method,
}: TemplateDownloadProps) => {
  const { info } = useAlert();
  const [loading, setLoading] = useState(false);

  const onDownloadClick =  useCallback(async () => {
    setLoading(true);
    const response = await method();
    if (response.code === 200) {
      info(response.message);
    }
    setLoading(false);
  }, [method]);

  return <Button 
    variant='outline' 
    colorScheme='brand'  
    onClick={onDownloadClick} 
    isLoading={loading}
    leftIcon={<MdDownload size='24px' />}
  >
    {label}
  </Button>; 
};